import { useDisclosure } from '@chakra-ui/react';
import React from 'react';

import EducationalDrawer from 'Containers/_drawers/EducationalDrawer';
import { TextField } from 'Containers/App/types';
import { useTextContext } from 'Contexts/textContext';
import { Button, Icon, Paragraph } from 'DesignLibrary/atoms';
import Text from 'Shared/Text';

import { CallOutCardWrapper, Wrapper } from './styled';

export const CallOutCard = ({ recommendation, type }) => {
  const {
    isOpen: noDeductibleIsOpen,
    onOpen: noDeductibleOnOpen,
    onClose: noDeductibleOnClose,
  } = useDisclosure();
  const { locale } = useTextContext();
  const isSpanishNoDeductible = locale === 'es-US' && type === 'no_deductible';

  const isOpen = noDeductibleIsOpen;
  const handleOpenInfoModal = noDeductibleOnOpen;
  const handleCloseInfoModal = noDeductibleOnClose;

  const isSurest = recommendation?.plan?.carrier_name === 'Surest';
  const callOutText = isSurest ? 'text_surest' : 'text';
  const callOutHeaderText = isSurest ? 'header_surest' : 'header';

  return (
    <CallOutCardWrapper data-testid="noDedeuctible-callout-card">
      <Wrapper>
        <div className="left-side-callout">
          <div className="left-side-callout-icon">
            <Icon type="BellRinging" weight="duotone" color="--primary-blue" />
          </div>
          <Paragraph size="small" color="--text-black">
            <strong className="callout-header-style">
              <Text
                field={
                  `health_section.recommendation.no_deductible_plan_callout.${callOutHeaderText}` as TextField
                }
              />
              &nbsp;
            </strong>
            <br />
            <Text field={`health_section.recommendation.no_deductible_plan_callout.${callOutText}`} />
          </Paragraph>
        </div>
        <div className="right-side-callout">
          <Button
            size="small"
            onClick={handleOpenInfoModal}
            data-testid="learn-more-plan-eligibility"
            buttonType="secondary"
            stretch
            justify="space-between"
          >
            <Text field="health_section.recommendation.no_deductible_plan_callout.buttonText" />
          </Button>
        </div>
        <EducationalDrawer
          handleClose={handleCloseInfoModal}
          isOpen={isOpen}
          infoType={type}
          employerContribution={null}
          selectedPlan={recommendation}
          shouldShowEducationalVideo={!isSpanishNoDeductible} // Hide video when language is spanish(es-US) for no-deductible plan
        />
      </Wrapper>
    </CallOutCardWrapper>
  );
};
